import { useEffect, useState } from 'react'
import CategoriesSection from './sections/categories/Categories.section'
import styles from './Templates.section.module.css'
import RequirementsSection from './sections/requirements/Requirements.section'
import DocumentsSection from './sections/documents/Documents.section'
import { DragDropProvider, type DragEndEvent, type DragOverEvent } from '@dnd-kit/react'
import { useRequirementsMutations } from '../../hooks/templates/requirements/useRequirements'
import TagsSection from './sections/tags/Tags.section'
import { useTags } from '../../hooks/templates/tags/useTags'



export default function TemplatesSection() {   
    const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null)
    const [selectedTagId, setSelectedTagId] = useState<number | null>(null)
    const [dragOver, setDragOver] = useState<string>("")

    const {data: tags} = useTags(selectedCategoryId)
    const {createRequirement} = useRequirementsMutations()    

    const handleDragOver = ({operation} : DragOverEvent) => {
        const dragOver = operation.target?.id as string | null        
        setDragOver(dragOver ?? "")
    }

    const handleDragEnd = ({canceled, operation}: DragEndEvent) => {
        if(canceled) return;        
        
        const target = operation.target
        const source = operation.source
        
        if(!target) return
        setDragOver("")
        
        if(!source) return
        
        if(!selectedCategoryId || !selectedTagId) return;
        

        console.log(target.id, source)
        
        if(target.id === "requirements-section") {
            createRequirement.mutate({
                categoryId: selectedCategoryId,
                tagId: selectedTagId,
                data: {
                    documentId: Number(source.id)
                }
            })
        }
    }


    const findTagBaseId = () => {
        if(tags && tags.length > 0)  return tags.find(tag => tag.isBase)?.id ?? tags[0].id        
        return null    
    }

    useEffect(() => setSelectedTagId(findTagBaseId()), [tags])

    return (        
        <section className={styles.section}>
            <CategoriesSection 
                selectedCategoryId={selectedCategoryId} 
                setSelectedCategoryId={setSelectedCategoryId}
            />
            
            <div className={styles.separatorv}></div>

            <DragDropProvider onDragOver={handleDragOver} onDragEnd={handleDragEnd}>
                <div className={styles.middlesection}>
                    { selectedCategoryId &&
                        <TagsSection 
                        tags={tags}
                            selectedCategoryId={selectedCategoryId}          
                            selectedTagId={selectedTagId}
                            setSelectedTagId={setSelectedTagId}
                            findTagBase={findTagBaseId}
                        />
                    }

                    <RequirementsSection       
                        isDragOver={dragOver === "requirements-section"}                    
                        selectedTagIsBase={findTagBaseId() === selectedTagId}
                        selectedCategoryId={selectedCategoryId}          
                        selectedTagId={selectedTagId}
                    />

                </div>
                
                <div className={styles.separatorv}></div>
                
                <DocumentsSection/>
            </DragDropProvider>
        </section>        
    )
}
